import { useCallback, useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/apiClient";
import { resolveImageUrl } from "../lib/images";

export default function PopupAnnouncement() {
    const [popup, setPopup] = useState(null);
    const [open, setOpen] = useState(false);

    const fetchPopup = useCallback(async () => {
        try {
            const { data } = await api.get("/popups/active");
            if (!data) return;
            const dismissedId = sessionStorage.getItem("cdc_popup_dismissed");
            if (dismissedId === data.id) return;
            setPopup(data);
            setOpen(true);
        } catch (_e) {
            // ignore
        }
    }, []);

    useEffect(() => {
        fetchPopup();
    }, [fetchPopup]);

    const close = () => {
        if (popup) sessionStorage.setItem("cdc_popup_dismissed", popup.id);
        setOpen(false);
    };

    if (!open || !popup) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-[#3D1F0F]/70 px-4"
            data-testid="popup-overlay"
        >
            <div className="relative max-w-md w-full bg-[#FFF1E0] border border-[#E4D1BB] rounded-2xl p-8 shadow-xl">
                <button
                    type="button"
                    aria-label="Fermer"
                    className="absolute top-3 right-3 text-[#6B4226] hover:text-[#3D1F0F]"
                    onClick={close}
                    data-testid="popup-close"
                >
                    <X />
                </button>
                {popup.image_url && (
                    <img
                        src={resolveImageUrl(popup.image_url)}
                        alt=""
                        className="w-full h-44 object-cover rounded-xl mb-4"
                    />
                )}
                <h3 className="font-serif-display text-2xl text-[#2A1408] mb-5">
                    {popup.title}
                </h3>
                <p className="text-[#5C3D2E] whitespace-pre-line leading-relaxed">{popup.content}</p>
                {popup.link_url && (
                    <a
                        href={popup.link_url}
                        target="_blank"
                        rel="noreferrer"
                        className="brand-btn inline-block mt-5"
                        data-testid="popup-link"
                    >
                        En savoir plus
                    </a>
                )}
            </div>
        </div>
    );
}
